window.megaMenuDescriptions = {
  "Amenities":
    "An inventory of all the amenities and services at your disposal.",

  "Weddings":
    "Let our beautiful grounds host the beginning of your union.",

  "Events & Corporate Meetings":
    "Host a small meeting, or a large get together with your peers.",

  "Jim & Garry's Pub":
    "The perfect place to relax and unwind before or after your golf game.",

  "lago Restaurant":
    "Contemporary gourmet cuisine with an extensive wine collection.",

  "lago Gourmet Express":
    "Fresh food to-go for corporate events or social functions.",

  "Pure Platinum Auto Spa":
    "Welcome to your convenient on-site deluxe automotive spa service.",

  "What's New":
    "See what's happening lately around Eagles Nest.",

  "Shop Online":
    "Buy some gear.",

  "Course":
    "The award winning layout offers a truly unique links style golf experience.",

  "Rates & Packages":
    "View our seasonal green fees, passes, packages and programs.",

  "Host a Tournament":
    "Host an intimate event for 24, or a full field event of 144 players."
};
